import { T_IAppSettings } from '@cgs/common';
import { AppSettings, AppSettingsService } from '@cgs/machines';
import { Container, EventDispatcher, EventStream, InstanceLifetime } from '@cgs/wge';

export interface SantaAppSettings extends AppSettings {}

export class SantaAppSettingsService extends AppSettingsService<SantaAppSettings> {
  private readonly gameSettingsChangedDispatcher = new EventDispatcher<SantaAppSettings>();

  public readonly onGameSettingsChanged: EventStream<SantaAppSettings> =
    this.gameSettingsChangedDispatcher.eventStream;

  constructor(container: Container) {
    super(container);

    // container.register(T_IAppSettings, () => this.settings, {
    //   lifetime: InstanceLifetime.Singleton,
    // });

    // const _launchParams = container.resolve<TrifectaLaunchParamsDto>(TRIFECTA_TRIFECTA_LAUNCH_PARAMS_TOKEN);
  }
}
